import type { Project } from '../types/executive'

export const projects: Project[] = [
  {
    name: 'Kaiser Permanente Los Angeles Medical Center',
    location: 'Los Angeles, CA — Sunset Blvd Campus',
    sector: 'Healthcare',
    value: '$410M',
    facts: ['460 Acute-Care Beds', '1,000,000 SF Campus', 'CMAR'],
    role: 'Project Executive',
    description:
      'Ground-up replacement hospital delivered across an active 1,000,000 SF campus, requiring sequential OSHPD/HCAI inspections, California seismic compliance, and phasing that kept the adjacent hospital fully operational with no clinical downtime.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/69587a4a-f017-45aa-a18e-227e9aa5f3a1.jpg',
  },
  {
    name: 'LAX APM Terminal Cores',
    location: 'Los Angeles International Airport',
    sector: 'Aviation',
    value: '$490M',
    facts: ['3 Terminal Cores', 'Zero Critical Claims', 'Design-Build'],
    role: 'Vice President, Western Region',
    description:
      'Added 300,000 SF of vertical circulation at Tom Bradley International, Terminal 5.5, and Terminal 7, connecting passengers to the Automated People Mover. Delivered on landside-only access with public egress open 24/7 — ASCE California Outstanding Airport Project and ENR Best Project Award of Merit.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/764922e9-4e05-443f-b2b8-9dc1f9663c39.jpg',
  },
  {
    name: 'LAX Gateway Improvements',
    location: 'Los Angeles International Airport',
    sector: 'Aviation',
    value: '$120M',
    facts: ['15 Light Pylons', 'Design-Build', 'Multi-Agency'],
    role: 'Pursuit & Team Assembly Lead',
    description:
      'Reimagining of the LAX civic gateway — control tower, illuminated pylons, and monumental signage — coordinated across LADBS, LADOT, Metro, Caltrans, the FAA, and Los Angeles World Airports.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8df0e279-2e96-4a75-b237-5227bd7b664c.jpg',
  },
  {
    name: 'San Bernardino Justice Center',
    location: 'San Bernardino, CA',
    sector: 'Civic',
    value: '$339.8M',
    facts: ['383,745 SF', '11 Stories', '35 Courtrooms'],
    role: 'Project Executive',
    description:
      'Led cross-functional estimating, scheduling, and engineering teams through a complex competitive public-sector pursuit, aligning design with budget to secure the award for an 11-story courtroom tower and 3-story linear podium.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/57e28007-8920-4cc2-8058-b725e7e6b892.jpg',
  },
  {
    name: 'McCormick Place South Hall Expansion',
    location: 'Chicago, IL',
    sector: 'Civic',
    value: '$675M',
    facts: ['2.9 MSF', 'Joint Venture', 'Design-Build'],
    role: 'Design Management & Procurement',
    description:
      'One of the largest exhibition-hall expansions in the country, delivered by a Clark / Hunt / Morse Diesel joint venture. Responsible for design development, GMP assembly, trade procurement, and oversight of the concrete superstructure package.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/572b6d51-6ca1-4f5a-9774-c7844139e4e1.jpg',
  },
  {
    name: 'Campus Point',
    location: 'San Diego, CA',
    sector: 'Commercial',
    value: '$80M',
    facts: ['3 Buildings', 'Life Science Conversion', 'Joint Venture'],
    role: 'Principal-in-Charge',
    description:
      'Repositioned a “B” occupancy office campus in La Jolla into a life science campus, including new interiors, MEP, process piping, and dynamic glazing. Led development and execution of the JV agreement and overall project oversight.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/049b5ab0-5369-4a64-ae2e-b80d3fa16e34.jpg',
  },
]

export const projectSectors = ['All', 'Healthcare', 'Aviation', 'Civic', 'Commercial'] as const
